import { clientesBack } from '@/common/api/https'

/**
 * Obtiene el menú de navegación desde clientes_service.
 * @param {{ idUsuario?: string|number, contrato?: string|number }} params
 * @returns {Promise<import("../common/ds/Menu/Menu.types").MenuNode[]>}
 */
export async function getMenu({ idUsuario, contrato } = {}) {
  const { data } = await clientesBack.get('/v2/menu', {
    params: { idUsuario, contrato },
  })
  return data
}
